module.exports = __webpack_public_path__ + "static/media/call.923801ae.svg";